export const formatMetricValue = (
  value: string,
  type: string,
  useCompactNotation: boolean = false,
): string => {
  switch (type) {
    case "TYPE_PERCENT":
      return parseFloat(value).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        style: "percent",
      });
    case "TYPE_FLOAT":
      return parseFloat(value).toLocaleString(undefined, {
        useGrouping: true,
        maximumFractionDigits: 2,
        notation: useCompactNotation ? "compact" : "standard",
      });
    case "TYPE_INTEGER":
      return parseInt(value).toLocaleString(undefined, {
        useGrouping: true,
        notation: useCompactNotation ? "compact" : "standard",
      });
    default:
      return value;
  }
};
